import ChartistGraph from "react-chartist";

const CustomChart = (props) => {
    return <ChartistGraph type={props.type} data={props.data} options={props.options} {...props} />;
};

export default CustomChart;
